import { getPriorityIdFromAri } from '@jira/issue__parse-issue-url/src/id-from-ari/index.tsx';
import type { NullableOption } from '@atlassian/jira-issue-field-priority-editview-full/src/ui/priority/types.tsx';
import type { AggJiraPriority } from './types.tsx';

export const transformOptionToAgg = (option: NullableOption): AggJiraPriority =>
	option
		? {
				id: option.value,
				iconUrl: option.iconUrl,
				name: option.label,
				priorityId: getPriorityIdFromAri(option.value),
			}
		: option;
